import React from 'react';
import { Box } from '@mui/material';
import { radius } from '@/shared/theme/tokens';

/** Inline keyboard key cap for cheatsheets and hints. */
export const Kbd: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    component="kbd"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 22,
      height: 22,
      px: 0.75,
      borderRadius: radius.sm,
      border: 1,
      borderColor: 'divider',
      bgcolor: 'action.hover',
      color: 'text.secondary',
      fontSize: 11,
      fontFamily: 'inherit',
      lineHeight: 1,
      boxShadow: '0 1px 0 rgba(0,0,0,0.06)',
    }}
  >
    {children}
  </Box>
);
